import React, { useRef } from 'react';
import { Header } from './components/Header';
import './styles/ServiceLetter.css';
import { useServiceLetterContext } from './hooks/useServiceLetterContext';
import Toast from '../../Util/Toast/Toast';
import Loading from '../../Dashboards/Common/Loading';
import { Project } from './components/Project';
import PDFGeneratorButton from './components/PDFGeneratorButton';

export const ServiceLetter = () => {
    const { state } = useServiceLetterContext();
    const headerRef = useRef(null);

    if (state.isError) {
        Toast.error('Erro ao carregar carta de serviços');
        return null;
    }

    if (state.isLoading) {
        return <Loading />;
    }

    return (
        <section className="d-flex flex-column">
            <PDFGeneratorButton
                headerRef={headerRef}
                serviceLetters={state.serviceLetters}
            />

            <div
                id="service-letter-header"
                ref={headerRef}
                className="service-letter-header"
            >
                <Header />
            </div>

            <div className="service-letter">
                {state.serviceLetters.map((serviceLetter, index) => (
                    <div
                        key={serviceLetter.id}
                        id={`serviceLetter-${index}`}
                        className="service-letter-page"
                    >
                        <Project
                            project={serviceLetter}
                            reverse={index % 2 !== 0}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};
